// extracted by mini-css-extract-plugin
export var grid = "thumb-grid-module--grid--1LLx-";
export var gridItem = "thumb-grid-module--grid-item--yu0zy";
export var title = "thumb-grid-module--title--CRE-J";